/**
 * Fiscal Registration
 * Fiskal Cloud Keycloak API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: info@deutsche-fiskal.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { LocaleDTO } from './locale-dto';


/**
 * Defines a user body
 */
export interface UpdateUserBodyDTO { 
    /**
     * Firstname
     */
    firstname: string;
    /**
     * Lastname
     */
    lastname: string;
    /**
     * phone number
     */
    phoneNumber?: string;
    /**
     * URL of the user\'s profile picture. The URL MUST refer to an image file.
     */
    picture?: string;
    /**
     * User settings (e.g. email notifications) * `email.fcc` - boolean value (`true`/`false`) enable / disable sending FCC emails * `email.export` - boolean value (`true`/`false`) enable / disable sending export emails * `email.archiving` - boolean value (`true`/`false`) enable / disable sending Archiving emails 
     */
    settings?: { [key: string]: string; };
    locale?: LocaleDTO;
}

export class ClsUpdateUserBodyDTO { 
    /**
     * Firstname
     */
    firstname: string = undefined;
    /**
     * Lastname
     */
    lastname: string = undefined;
    /**
     * phone number
     */
    phoneNumber?: string = undefined;
    /**
     * URL of the user\'s profile picture. The URL MUST refer to an image file.
     */
    picture?: string = undefined;
    /**
     * User settings (e.g. email notifications) * `email.fcc` - boolean value (`true`/`false`) enable / disable sending FCC emails * `email.export` - boolean value (`true`/`false`) enable / disable sending export emails * `email.archiving` - boolean value (`true`/`false`) enable / disable sending Archiving emails 
     */
    settings?: { [key: string]: string; } = undefined;
    locale?: LocaleDTO = undefined;
}



